<div class="standard-datepicker-container field">
    <input #datetimepicker class="standard-datepicker" (blur)="inputBlur()" [ngModel]="dateString | date: dateFormat" (change)="onInputChange($event)" (keyup.enter)="keyupEnter()" [disabled]="disabled" />

    <button #calendar="ngbPopover" class="datepicker-toggle" [ngbPopover]="calendarContent" container="body" [disabled]="disabled" type="button" [placement]="placement">
        <i class="far fa-calendar-alt"></i>
    </button>

    <label [for]="id" class="datepicker-caption">{{ label }}</label>
    @if (hint?.length) {
        <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
    }

    @if (controlDirective?.invalid && (controlDirective?.dirty || controlDirective?.touched)) {
        <div class="form-text text-danger">
            @if (controlDirective?.errors?.required) {
                <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.nameRequired' | translation: { name: label } | async }}</div>
            }
            @if (controlDirective?.errors?.invalidTime) {
                <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.invalidTime' | translation: { name: label } | async }}</div>
            }
        </div>
    }
</div>

<ng-template #calendarContent>
    @switch (dateTimePickerType) {
        @case (DateTimePickerType.DatePicker) {
            <div>
                <div>
                    <ngb-datepicker container="body" id="datepicker" #datepicker name="datepicker" [ngModel]="datetime" (ngModelChange)="onDateChange($event, datepicker)" (navigate)="refreshDatepicker($event, datepicker)"> </ngb-datepicker>
                    <hr />
                    <button class="btn btn-primary" (click)="closeCalendar()">{{ 'actions.ok' | translation | async }}</button>
                </div>
            </div>
        }
        @case (DateTimePickerType.TimePicker) {
            <div>
                <div>
                    <ngb-timepicker container="body" #timepicker name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)" [seconds]="seconds" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep">
                    </ngb-timepicker>
                    <hr />
                    <button class="btn btn-primary" (click)="closeCalendar()">{{ 'actions.ok' | translation | async }}</button>
                </div>
            </div>
        }
        @case (DateTimePickerType.DateTimePicker) {
            <div>
                <div>
                    <ngb-datepicker container="body" id="datepicker" #datepicker name="datepicker" [ngModel]="datetime" (ngModelChange)="onDateChange($event, datepicker)" (navigate)="refreshDatepicker($event, datepicker)"> </ngb-datepicker>
                    <div class="mt-auto">
                        <ngb-timepicker #timepicker name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)" [seconds]="seconds" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep">
                        </ngb-timepicker>
                    </div>
                    <hr />
                    <button class="btn btn-primary" (click)="closeCalendar()">{{ 'actions.ok' | translation | async }}</button>
                </div>
            </div>
        }
    }
</ng-template>
